import { HighlightedText } from 'src/shared/utils/text-highlighter/TextHighlighter'
import { useMediaQuery } from 'src/lib/use-media-query'
import styles from 'src/styles/common.module.scss'

const BREAKPOINT_RULES: Record<string, string[]> = {
    desktop: ['DES'],
    tablet: ['ET'],
    mobile: ['ROUE', 'DES'],
    small: ['LA', 'DES'],
}

export const TextHeaderFr = () => {
    const isDesktop = useMediaQuery('(min-width: 1024px)')
    const isTablet = useMediaQuery('(min-width: 768px)')
    const isMobile = useMediaQuery('(min-width: 540px)')

    let breakAfterWords = BREAKPOINT_RULES.small

    if (isDesktop) {
        breakAfterWords = BREAKPOINT_RULES.desktop
    } else if (isTablet) {
        breakAfterWords = BREAKPOINT_RULES.tablet
    } else if (isMobile) {
        breakAfterWords = BREAKPOINT_RULES.mobile
    }

    return (
        <HighlightedText
            text="FAITES TOURNER LA ROUE ET RECEVEZ DES TOURS GRATUITS"
            highlights={[{ word: 'TOURS' }, { word: 'GRATUITS' }]}
            breakAfterWords={breakAfterWords}
            className={styles.text_header}
        />
    )
}
